import React from "react"
import { View, StyleSheet, Text } from "react-native"
import { theme } from "@common/theme/theme"

/**
 * Pastille « ☀️ Cours d'été » — eyebrow de marque partagée par les écrans du
 * funnel non illustrés (configurateur, reveau programme). Centralise le style
 * pour garder l'homogénéité visuelle d'un écran à l'autre.
 */
const SummerEyebrow = ({ label = "☀️ Cours d'été", style }) => (
    <View style={[styles.eyebrow, style]}>
        <Text style={styles.eyebrowText}>{label}</Text>
    </View>
)

const styles = StyleSheet.create({
    eyebrow: {
        alignSelf: "flex-start",
        backgroundColor: theme.colors.warningLight,
        borderRadius: 999,
        paddingVertical: 4,
        paddingHorizontal: 12,
        marginBottom: 12,
    },
    eyebrowText: {
        fontFamily: "Montserrat-Bold",
        fontSize: 12,
        color: theme.colors.warning,
    },
})

export default SummerEyebrow
